import "moment/locale/pt-br";

import * as routes from "../../utils/contants/urls";
import * as urlsApi from "../../utils/contants/urlsApi";

import {
  buildCode,
  buildErroHandleItems,
  buildPagination,
  buildTimeFromSeconds,
  setHoursInDate
} from "../../helpers/sharedHelpers";
import { put, select, takeLatest } from "redux-saga/effects";

import API from "../../utils/API";
import { Types as MessageTypes } from "../ducks/messages";
import { Types } from "../ducks/doubts";
import { history } from "../../utils/routes";
import { kindStages } from "../../locale/index";
import moment from "moment";

moment.locale("pt-BR");

function requestCandidadesAnswers(body){
  return API.put(
    `${urlsApi.REQUEST_CANDIDATES_ANSWERS}`,
    body
  )
  .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

const filterduvidasList = payload => {
  const body = {
    idStatus : payload.idStatus,
    idStatusList: payload.idStatusList,
    cpfList: payload.cpfList,
    idMotivoList: payload.idMotivoList,
    numeroPagina: payload.NumeroPagina,
    cpf: payload.cpf,
    respostaAdm: payload.respostaAdm,
    candidato_Id: payload.candidato_Id,
  };

  return body;
};


function requestCandidadesDoubtsList(body) {
  return API.put(
    `${urlsApi.REQUEST_CANDIDATES_DOUBTS}`,
    body
  )
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}
function* getduvidasListVacancyDoubts({ payload }) {
  

  try {

    const buildFilter = {...payload};

    let actualPage;
    if (buildFilter && buildFilter.firstPage) {
      actualPage = 1;
    } else {
      actualPage = buildFilter.NumeroPagina || (yield select(getActualPage));
    }
        let actualItens = buildFilter && buildFilter.recoveredFilter && buildFilter.quantidadeItens ? payload.quantidadeItens : 50;
        buildFilter.quantidadeItens = actualItens;
        buildFilter.NumeroPagina = actualPage;

    const { lista, paginacao } = yield requestCandidadesDoubtsList(filterduvidasList(payload));
  
    const duvidasList = {
      duvidas: lista.map(e => ({
        id: e.id,
        vaga_Id: e.vaga_Id,
        candidato_Id: e.candidato_Id,
        candidato: e.candidato,
        motivo: e.motivo,
        assunto: e.assunto,
        descricao: e.descricao,
        statusDuvida: e.statusDuvida,
        respostaAdm: e.respostaAdm,
        dataCriacao: e.dataCriacao,
        cpf: e.cpf
      })),
    };
    let duvidas;
    const stateCandidateList = yield select(getStateduvidasList);

    duvidas = duvidasList.duvidas;

    const AllduvidasList = { duvidas: duvidas}

    const paginacaoNumber = {...paginacao, page: buildFilter.numeroPagina}
    const pagination = buildPagination(
      paginacaoNumber,
      buildFilter,
      AllduvidasList.duvidas,
      stateCandidateList,
      50,
    );

    yield put({
      type: Types.DOUBTS_LIST_SUCCESS,
      duvidas: AllduvidasList.duvidas,
      duvidasList,
      pagination
    });
  } catch (error) {
    yield put({ type: Types.DOUBTS_LIST_FAIL, error });
  }
}

function* postRespostaDuvidas({ payload }) {
  

  try {

    const body = {
      respostaAdm: payload.respostaAdm,
      candidato_Id: payload.candidato_Id,
      id: payload.id,
    };

    yield requestCandidadesAnswers(body)

    yield put({
      type: Types.DOUBTS_ANSWERS_SUCCESS,
    });
  } catch (error) {
    yield put({ type: Types.DOUBTS_ANSWERS_FAIL, error });
  }
}

const getActualPage = state => state.doubts?.page || 1;
const getStateduvidasList = state => state.doubts?.duvidas;


export function* watcherSaga() {
  yield takeLatest(Types.DOUBTS_LIST_REQUEST, getduvidasListVacancyDoubts);
  yield takeLatest(Types.DOUBTS_ANSWERS_REQUEST, postRespostaDuvidas )
}
